/**
 * @generated SignedSource<<b2547ac555ac0d6bfdbcfcafb3a13fe2>>
 * @relayHash 681f21b7300129245c50c363311aa70c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2bb63c531428b6a40e0453bb2cb8bf8f54cb0c0685c6a2da0e2f840003ebe3af

import type { ConcreteRequest, Query } from 'relay-runtime';
export type MoreProjectsQuery$variables = {
  cloudId: string;
  currentURL?: AGG$URL | null | undefined;
};
export type MoreProjectsQuery$data = {
  readonly jira_projectsSidebarMenu: {
    readonly moreFavourites: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly avatar: {
            readonly large: string | null | undefined;
          } | null | undefined;
          readonly defaultNavigationItem: {
            readonly url?: string | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly name: string;
          readonly projectKey: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly moreRecents: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly avatar: {
            readonly large: string | null | undefined;
          } | null | undefined;
          readonly defaultNavigationItem: {
            readonly url?: string | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly name: string;
          readonly projectKey: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type MoreProjectsQuery = {
  response: MoreProjectsQuery$data;
  variables: MoreProjectsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "currentURL"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "currentURL",
    "variableName": "currentURL"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "large"
    }
  ]
},
v5 = {
  "alias": "projectKey",
  "kind": "ScalarField",
  "name": "key"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "JiraNavigationItem",
  "abstractKey": "__isJiraNavigationItem"
},
v7 = [
  {
    "concreteType": "JiraProjectEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  }
],
v8 = [
  {
    "concreteType": "JiraProjectEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "MoreProjectsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraProjectsSidebarMenu",
        "kind": "LinkedField",
        "name": "jira_projectsSidebarMenu",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "moreFavourites",
            "plural": false,
            "selections": (v7/*: any*/)
          },
          {
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "moreRecents",
            "plural": false,
            "selections": (v7/*: any*/)
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MoreProjectsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraProjectsSidebarMenu",
        "kind": "LinkedField",
        "name": "jira_projectsSidebarMenu",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "moreFavourites",
            "plural": false,
            "selections": (v8/*: any*/)
          },
          {
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "moreRecents",
            "plural": false,
            "selections": (v8/*: any*/)
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "2bb63c531428b6a40e0453bb2cb8bf8f54cb0c0685c6a2da0e2f840003ebe3af",
    "metadata": {},
    "name": "MoreProjectsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "816c3a92778c467b92ad6692595d4492";

export default node;
